/** Chemin de la page d'édition d'un lieu. */
export function editLocationPath(orgId: number, type: string, id: number): string {
  return `/o/${orgId}/lieux/${encodeURIComponent(type)}/${id}`
}

/** Types de lieux qu'on peut créer ou modifier avec le formulaire du site. */
export const EDITABLE_TYPES = ['refuge', 'camping', 'organization'] as const
